<template>
  <div class="guide-detail mx-5">
    <Loading :show="isLoading">
      <!-- <h1>{{ Item.name }}</h1> -->
      <CMSHtmlWrapper :value="Item.body" />
    </Loading>
  </div>
</template>
<script setup lang="ts">
  import { cdnApi } from '@/helpers/api'
  import { useAsyncState } from '@vueuse/core'
  import { useRoute } from 'vue-router'

  const route = useRoute()

  // For Ingame Hide UIs (GNB, Header, Footer, etc.)
  watch(
    () => route.query,
    (newQuery) => {
      if (newQuery.ingame === 'true') {
        document.body.classList.add('ingame')
      } else {
        document.body.classList.remove('ingame')
      }
    },
    { immediate: true }
  )

  interface IGuideItem {
    body: string
    name: string
    id: number
    ParentName: string
  }

  const { state: Item, isLoading } = useAsyncState(
    cdnApi.get(`/ms-guides/${route.params.id}`).then(({ data }) => data as IGuideItem),
    { body: '', name: '', id: 0, ParentName: '' }
  )
</script>
<style lang="scss">
  .ingame {
    #globalNavigation,
    header,
    #globalFooter,
    .media-platforms,
    .overlay-cta__overlay-img,
    .overlay-cta__toggle-icon {
      display: none;
    }
    .maple-guide-detail {
      .filterbox,
      .page-banners,
      .play-now-btn {
        display: none;
      }
    }
  }
  .guide-detail {
    min-height: 400px;
    // padding: 30px;
    font-size: max(pxToRem(20), 14px);
    dl,
    ul,
    ol,
    table {
      margin: 20px 0;
    }
    dl,
    ul,
    ol {
      padding-left: 20px;

      li {
        margin-bottom: 10px;
        &::marker {
          color: var(--accent-color1);
        }
      }
      dl,
      ul,
      ol {
        margin-top: 2px;
        margin-bottom: 2px;
      }
    }
    img {
      max-width: 100%;
    }
  }
  @media #{$tablet} {
    .guide-detail {
      font-size: max(pxToRemTablet(18), 12px);
    }
  }
</style>
